package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.AcquireLockResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class AcquireLockUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String): AcquireLockResult = repo.acquireLock(ticketId)
}
